<ejs-grid #grid
          class="grid-with-toolbar grid-no-filter grid-configuration"
          width="100%"
          rowHeight="38"
          [dataSource]="data"
          [allowSorting]="true"
          [allowPaging]="true"
          [pageSettings]='pageSettings'
          [allowFiltering]="true"
          [filterSettings]="filterSettings"
          (rowSelected)="onRowSelected($event)"
          (recordDoubleClick)="onRowDoubleClick($event)"
          (dataBound)="onDataBound()">
  <e-columns>
    <e-column field="id"
              [visible]="false"
              [isPrimaryKey]="true"></e-column>
    <e-column field="configurationName"
              headerText="{{'i18n.domain.export-configuration.templates.column-headers.name' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="type"
              headerText="{{'i18n.domain.export-configuration.templates.column-headers.type' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{getTypeName(data.type) | translate}}
      </ng-template>
    </e-column>
    @if(mode === null){
      <e-column field="mode"
                headerText="{{'i18n.domain.export-configuration.templates.column-headers.mode' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{getModeName(data.mode) | translate}}
        </ng-template>
      </e-column>
    }
  </e-columns>
</ejs-grid>
